import React from "react";
import { Card, Typography } from "antd";

const { Title, Paragraph, Link } = Typography;

const DeleteAccountPage = () => {
  return (
    <div style={{ maxWidth: 700, margin: "40px auto", padding: "0 20px" }}>
      <Card>
        <Typography>
          <Title level={2}>Удаление аккаунта в приложении "Финансы - доходы и расходы"</Title>
          <Paragraph>
            Эта страница относится к мобильному приложению "Финансы - доходы и расходы".
          </Paragraph>
          <Paragraph>
            Название приложения в Google Play: "Финансы - доходы и расходы"
          </Paragraph>
          <Paragraph>
            Package name: simolapps.moneta
          </Paragraph>
          <Paragraph>
            Разработчик: Mukhammadnakshubandi Omarov
          </Paragraph>
          <Paragraph>
            Пользователь может запросить удаление аккаунта и связанных данных,
            используемых в приложении, включая:
          </Paragraph>
          <ul>
            <li>Номер телефона</li>
            <li>Имя профиля</li>
            <li>Данные аккаунта</li>
            <li>Финансовые записи</li>
            <li>Категории</li>
            <li>Счета</li>
            <li>Связанные пользовательские данные</li>
          </ul>
          <Paragraph>
            Чтобы удалить аккаунт, отправьте запрос одним из следующих способов:
          </Paragraph>
          <ul>
            <li>
              📧 Email: <Link href="mailto:simolapps@gmail.com">simolapps@gmail.com</Link>
            </li>
            <li>
              📱 WhatsApp: <Link href="https://wa.me/79285147009" target="_blank">+7 928 514-70-09</Link>
            </li>
          </ul>
          <Paragraph>
            После подтверждения личности аккаунт и связанные с ним данные будут
            удалены в течение 7 рабочих дней.
          </Paragraph>
          <Paragraph>
            Если у вас есть вопросы, пожалуйста, свяжитесь с нами по указанным выше контактам.
          </Paragraph>
          <Paragraph strong>Mukhammadnakshubandi Omarov</Paragraph>
        </Typography>
      </Card>
    </div>
  );
};

export default DeleteAccountPage;
